import { useEffect } from "react";

/**
 * Injects a schema.org JSON-LD <script> into <head> for GEO/AEO.
 * `id` keeps a single script per logical block; cleaned up on unmount.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    let s = document.getElementById(id);
    if (!s) {
      s = document.createElement("script");
      s.id = id;
      s.type = "application/ld+json";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(data);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, data]);
  return null;
}
